import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paycenter",
  "use": "icon-paycenter-usage",
  "viewBox": "0 0 34.99 28.24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.99 28.24\" class=\"icon\" id=\"icon-paycenter\"><path class=\"cls-1\" d=\"M31.49,28.24H3.5A3.5,3.5,0,0,1,0,24.74V3.5A3.5,3.5,0,0,1,3.5,0h28A3.5,3.5,0,0,1,35,3.5V24.74A3.5,3.5,0,0,1,31.49,28.24ZM3.5,2A1.5,1.5,0,0,0,2,3.5V24.74a1.5,1.5,0,0,0,1.5,1.5h28a1.5,1.5,0,0,0,1.5-1.5V3.5A1.5,1.5,0,0,0,31.49,2Z\" /><path class=\"cls-1\" d=\"M16.78,22a2.3,2.3,0,0,1-1.71-.75l-3.32-3.58a1,1,0,1,1,1.46-1.36l3.32,3.58c.18.19.32.19.5,0l6.54-7A1,1,0,1,1,25,14.16L18.5,21.21A2.33,2.33,0,0,1,16.78,22Z\" /><path class=\"cls-1\" d=\"M34,9.3H1a1,1,0,0,1,0-2H34a1,1,0,0,1,0,2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paycenter.svg
// module id = VEPN
// module chunks = 127